module.exports = __webpack_public_path__ + "static/img/4.e45fdb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/4.png
// module id = aJIf
// module chunks = 0